import React from 'react';

import {AnalyticsPanelId} from '../../../../libs/shared/core/src/store/panels/panelStateBase';
import {DiscardChangesDialog} from '../../../../libs/shared/ui/src/components/dialogs/discardChangesDialog';
import {useNavigationBlocking} from '../../../../srcCommon/app/navigationBlocking';
import {useAppSelector} from '../../../helpers/appReduxHelpers';
import {getUnsavedViewNavigationBlockerId} from '../../../store/panels/analytics/analyticsPanelSelectors';

/*
 * Types.
 */

interface ReportDiscardChangesProps {
  panelId: AnalyticsPanelId;
  hasDiffFilters: boolean;
}

/*
 * Component.
 */

export const ReportDiscardChanges = ({panelId, hasDiffFilters}: ReportDiscardChangesProps) => {
  const unsavedViewNavigationBlockerId = useAppSelector(getUnsavedViewNavigationBlockerId);
  const {didBlockNavigation, cancelNavigation, unblockNavigation} = useNavigationBlocking(
    panelId,
    hasDiffFilters,
    unsavedViewNavigationBlockerId,
  );

  const onDiscardChangeFilters = () => {
    unblockNavigation();
  };

  if (!didBlockNavigation) {
    return null;
  }

  return <DiscardChangesDialog onCancel={cancelNavigation} onDiscard={onDiscardChangeFilters} />;
};
